import React, { createElement, Fragment, useEffect, useRef, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
// eslint-disable-next-line no-unused-vars
import { InstantSearch, Configure, useHits, useSearchBox, ClearRefinements, CurrentRefinements } from 'react-instantsearch';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { render } from 'react-dom';
import { GaEvent } from '../../Libraries/EventTracking';
import { addClass, removeClass } from '../../Libraries/helpers';

import '@algolia/autocomplete-theme-classic';

const searchClient = algoliasearch(process.env.MIX_ALGOLIA_APP_ID, process.env.MIX_ALGOLIA_SEARCH_API_KEY);

const SearchBox = (props) => {

    const indexName = process.env.MIX_ALGOLIA_INDEX_SEARCH;

    const containerRef = useRef(null);
    const panelRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');

    // eslint-disable-next-line no-unused-vars
    const changeStatus = event => {
        setOpen(!open);

        if (open && query.length) {
            document.location = props.results + '?query=' + query;
        }

        if (!open || query.length) {
            setTimeout(() => removeClass(containerRef.current, 'opacity-0', 'w-0'), 10);
            setTimeout(() => addClass(containerRef.current, 'w-48'), 10);
            setTimeout(containerRef.current.querySelector('input').focus(), 300);

            new GaEvent({
                category: 'Search',
                action: 'Global Search',
                label: 'Opened',
            })
        } else {
            setTimeout(() => addClass(containerRef.current, 'opacity-0', 'w-0'), 10);
            setTimeout(() => removeClass(containerRef.current, 'w-48'), 10);

            new GaEvent({
                category: 'Search',
                action: 'Global Search',
                label: 'Closed',
            })
        }
    }

    const debouncePromise = (fn, time) => {
        let timerId = undefined;

        return function debounced(...args) {
            if (timerId) {
                clearTimeout(timerId);
            }

            return new Promise((resolve) => {
                timerId = setTimeout(() => resolve(fn(...args)), time);
            });
        };
    }
    const debounced = debouncePromise((items) => Promise.resolve(items), 300);

    useEffect(() => {
        if (!containerRef.current) {
            return undefined;
        }

        const search = autocomplete({
            detachedMediaQuery: 'none',
            container: containerRef.current,
            panelContainer: panelRef.current,
            placeholder: props.placeholder,
            classNames: {
                panel: 'z-[100] !left-auto !right-auto !top-auto',
                item: 'text-sm',
                form: '!bg-transparent !border-none focus-within:!shadow-none',
                inputWrapperPrefix: '!hidden',
                inputWrapperSuffix: '!h-10',
                inputWrapper: 'text-xs lg:text-sm',
                input: '!text-white placeholder:!text-white/60 !h-10',
                clearButton: '!text-white/60',
            },
            getSources() {
                return debounced([
                    {
                        sourceId: 'querySuggestions',
                        getItemInputValue: ({ item }) => item.query,
                        getItems({ query }) {
                            return getAlgoliaResults({
                                searchClient,
                                queries: [
                                    {
                                        indexName: indexName,
                                        query,
                                        params: {
                                            hitsPerPage: 5,
                                            facetFilters: ['language:' + props.language, 'enabled:1'],
                                        },
                                    },
                                ],
                            });
                        },
                        templates: {
                            item(params) {
                                const { item, html } = params;

                                return html`<a className="aa-ItemLink" href="${props.baseurl}${item.url}">
                            ${item.title}
                          </a>`;
                            },
                        },
                    },
                ]);
            },
            renderer: { createElement, Fragment, render },
            onSubmit({state}) {
                // console.log(state)
                document.location = props.results + '?query=' + state.query;
            },
            // eslint-disable-next-line no-unused-vars
            onStateChange({ prevState, state }) {
                setQuery(state.query)
            },
        });

        return () => {
            search.destroy();
        };
    }, [props.plugins]);

    return (
        <div className="grid relative">
            <div className="inline-flex items-center overflow-hidden">
                <div id="searchbox" className="transform opacity-0 duration-300 bg-transparent text-xs lg:text-sm mr-2 w-0 outline-none focus:outline-none appearance-none" ref={containerRef}></div>
                <div className="flex h-6 items-center">
                    <button onClick={ changeStatus } type="button" className="text-white focus:outline-none appearance-none md:hover:opacity-60 md:focus:opacity-60 transition ease-in-out duration-300">
                        <svg viewBox="0 0 15 16" width="15" height="16" xmlns="http://www.w3.org/2000/svg" className="flex">
                            <title>Search Button</title>
                            <path d="M10.4732661 9.63172273c.7022888-.95903807 1.122361-2.13703967 1.122361-3.41408697 0-3.19681205-2.60101534-5.7978274-5.79782739-5.7978274C2.60098767.41980836 0 3.02082371 0 6.21763576 0 9.4144478 2.60101535 12.0154632 5.7978274 12.0154632c1.27704729 0 2.45515962-.4201277 3.4141977-1.1224165l3.7982835 3.7982836 1.2612963-1.2612964c0-.0000276-3.7983388-3.79831117-3.7983388-3.79831117zm-4.6754387.59978289c-2.21338625 0-4.01386986-1.80048361-4.01386986-4.01386986S3.58444115 2.2037659 5.7978274 2.2037659c2.21338624 0 4.01386985 1.80048361 4.01386985 4.01386986s-1.80051129 4.01386986-4.01386985 4.01386986z" fill="currentColor"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div id="searchpanel" className="relative w-full" ref={panelRef}></div>
        </div>
    );
}

export default SearchBox
